import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {A0, SnapshotType} from '../../../shared/entities/A0.entity';
import {MapperService} from '../../../services/mapper.service';
import {MapCesiumComponent} from '../../../shared/cesium/map-cesium.component';
import {zip} from 'rxjs';
import {CdkDragEnd} from '@angular/cdk/drag-drop';
import {convertDimensionWithRatio} from '../../../shared/tools';
import { LayerLoadType } from 'src/shared/cesium/types';
import {PredictService} from '../../../services/predict.service';

@Component({
    selector: 'app-plan-map-3d',
    templateUrl: './map-3d.component.html',
    styleUrls: ['./map-3d.component.scss'],
    standalone: false
})

export class Map3dComponent implements OnInit {

  plan: A0;
  listSnapshot = [];
  currentSnapshot: any = {
    type: ''
  };

  titleInitialPosition = {x:0, y:0};

  _type = '';

  isLoadingLayer = false;
  mapReady = false;


  @ViewChild('map') mapComponent: MapCesiumComponent;

  constructor(
    public route: ActivatedRoute,
    public predictService: PredictService,
    public mapperService: MapperService
  ) {}

  ngOnInit(): void {
    this._type = this.route.snapshot.paramMap.get('type') as SnapshotType;
    this.currentSnapshot.type = this._type;

    this.getPlan(this.route.snapshot.paramMap.get('id'));
  }

  public getPlan(id): void {
    zip(
      this.mapperService.getPlan(id),
      this.mapperService.getSnapshotList(id)
    ).subscribe(([plan, listSnapshot]) => {
      this.listSnapshot = listSnapshot.filter(snapshot => snapshot.id_zoom.includes('ZOOM'));
      this.currentSnapshot = {...this.currentSnapshot, ...this.listSnapshot.find(a => a.id_zoom === this._type)};
      this.predictService.handleZones(plan.id_user).subscribe((listZone) => {
        this.plan = plan;

        if (listZone.length > 0) {
          this.plan.list_zone = listZone;
          this.plan.type_zone = Array.from(new Set(listZone.map((zone) => zone.type_zone))).length === 1
            ? listZone[0].type_zone
            : 'MULTI';
        }
      });
    }, (err) => {
      console.log('[Map3dComponent] -> getPlan(err) -> ', err);
    });
  }

  screenshot(): void {
    this.mapComponent.take3dScreenshot(this.currentSnapshot);
  }

  mapIsInit(): void {
    setTimeout(() => {
      if (this.currentSnapshot.title_position) {
        this.titleInitialPosition = convertDimensionWithRatio(
          [1500, 1500], this.getContainerDimension(),
          this.currentSnapshot.title_position
        );
      }
      if (this.currentSnapshot) {
        this.mapComponent.zoomOnSnapshot(this.currentSnapshot);
      }

      this.mapReady = true;
    });
  }

  domToCanvasPosition(item): any {
    const [elX, elY] = this.getItemCanvasPosition(item);

    const canvasWidth = 1500;
    const canvasHeight = 1500;

    const [containerWidth, containerHeight] = this.getContainerDimension();

    return `${Math.round(elX * (canvasWidth / containerWidth))},${Math.round(elY * (canvasHeight / containerHeight))}`
  }

  dragEnd(event: CdkDragEnd): void {
    const item = event.source.element.nativeElement;
    const positionType = event.source.element.nativeElement.id;
    this.currentSnapshot[positionType] = this.domToCanvasPosition(item);
  }

  getItemCanvasPosition(nativeElement): any {
    const transform = nativeElement.style.transform;
    return transform.match(/[0-9]*px/gm).map(a => a.replace('px', ''));
  }

  getContainerDimension(): any {
    return [
      Number(this.mapComponent.viewer._lastHeight),
      Number(this.mapComponent.viewer._lastWidth)
    ];
  }

  protected readonly LayerLoadType = LayerLoadType;
}
